import { useQuery } from '@tanstack/react-query';
import { fetchUserBumpInformation } from '~/api/user';

export default function useBumpInfo() {
  return useQuery(['bump-info'], fetchUserBumpInformation);
}
